import ArrayUtil from './ArrayUtil';

export const getRespondentOfSurveys = ({
  self, peers, managers, direct, others,
}) => {
  const res = [];
  res.push(self.respondent);
  if (ArrayUtil.isNotEmpty(peers)) {
    peers.forEach((survey) => {
      res.push(survey.respondent);
    });
  }

  if (ArrayUtil.isNotEmpty(managers)) {
    managers.forEach((survey) => {
      res.push(survey.respondent);
    });
  }

  if (ArrayUtil.isNotEmpty(direct)) {
    direct.forEach((survey) => {
      res.push(survey.respondent);
    });
  }

  if (ArrayUtil.isNotEmpty(others)) {
    others.forEach((survey) => {
      res.push(survey.respondent);
    });
  }

  return res;
};

export default getRespondentOfSurveys;
